import { CallMode } from "@/types";

export function callMode(state: any): CallMode {
  if (state.inCallMode) {
    return "inCall";
  }
  return "noCall";
}

export function availableStatus(state: any): boolean {
  const user = state.user || {};
  return user.available;
}
